import React from 'react';
import podiumImg from './images/podium.png';
import cupImg from './images/cup.png';
import logo from './images/logo.png';
import styles from './poduim.module.scss';
import { useGetTop5 } from '~/hooks/companies';

const renderName = (name: string) => {
  if (name === 'A.B.C.DISTRIBUTION') {
    return (
    <>
    A.B.C.
    <br />
    DISTRIBUTION
    </>
    );
  }
  return name;
};

const Podium = () => {
  const { data: providers = [] } = useGetTop5();
  return (
    <div className={styles.podium}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.title}>
        <div className={styles.top5}>
         <h1>
          Top 5 des fournisseurs<br/>
          en CA achat
          </h1>
          <img src={cupImg} alt="cup" />
        </div>
      </div>
      {providers.length > 2
      && < div className={styles.main}>
        <img src={podiumImg} alt="podium" />
        <div className={styles.top3}>
          <p>
            {renderName(providers[1].companyProvider.name.trim().toUpperCase())}
          </p>
          <p>
            {renderName(providers[0].companyProvider.name.trim().toUpperCase())}
          </p>
          <p>
            {renderName(providers[2].companyProvider.name.trim().toUpperCase())}
          </p>
        </div>
        {providers.length > 4
          && <div className={styles.last}>
            <div className={styles.box}>
              <div className={styles.item}>
                <div className={styles.pos}>
                  <p>4</p>
                </div>
                <p>{providers[3].companyProvider.name.trim().toUpperCase()}</p>
              </div>
              <div className={styles.item}>
                <div className={styles.pos}>
                  <p>5</p>
                </div>
                <p>{providers[4].companyProvider.name.trim().toUpperCase()}</p>
              </div>
            </div>
          </div>
        }
      </div>
      }
    </div>
  );
};

export default Podium;
